import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppUserDefaultStore, loadVatOrdersSetting, saveVatOrdersSetting } from '../../../stores/appUserDefaultStore';

export const OrderVatToggle: React.FC = () => {
  const { t } = useTranslation();
  const showExVatOrders = useAppUserDefaultStore(s => s.showExVatOrders);

  // Load VAT setting on component mount
  useEffect(() => {
    loadVatOrdersSetting();
  }, []);

  const handleToggle = async () => {
    try {
      await saveVatOrdersSetting(!showExVatOrders);
    } catch (error) {
      console.error('Failed to save Orders VAT setting');
    }
  };

  return (
    <div className="flex items-center gap-2 bg-muted/10 dark:bg-muted-dark/10 rounded-lg p-1">
      <button
        className={`px-3 py-1 rounded-md text-sm font-medium transition ${
          showExVatOrders
            ? 'bg-white dark:bg-card-dark shadow text-text dark:text-text-dark'
            : 'hover:bg-white/50 dark:hover:bg-card-dark/50 text-muted dark:text-muted-dark'
        }`}
        onClick={handleToggle}
        disabled={showExVatOrders}
      >
        {t('orderHistory.exclVat')}
      </button>
      <button
        className={`px-3 py-1 rounded-md text-sm font-medium transition ${
          !showExVatOrders
            ? 'bg-white dark:bg-card-dark shadow text-text dark:text-text-dark'
            : 'hover:bg-white/50 dark:hover:bg-card-dark/50 text-muted dark:text-muted-dark'
        }`}
        onClick={handleToggle}
        disabled={!showExVatOrders}
      >
        {t('orderHistory.inclVat')}
      </button>
    </div>
  );
};

export default OrderVatToggle;
